/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Stack from "@mui/material/Stack";
import Link from "@mui/material/Link";

// Material Kit 2 React components
import MKBox from "../../../components/MKBox";
import MKTypography from "../../../components/MKTypography";

import styles from "assets/scss/emtay.module.scss";

// i18n
import { useLanguage } from "i18n";

function FeaturesOne() {
  const { t } = useLanguage();

  const serviceLinks = [
    "/services#services-software-development",
    "/services#services-project-audits",
    "/services#services-technical-screening",
  ];

  return (
    <MKBox component="section" py={{ xs: 3, md: 4 }}>
      <Container>
        <Grid container alignItems="center">
          <Grid item xs={12} lg={5}>
            <MKTypography variant="h3" my={1}>
              {t("features.title")}
            </MKTypography>
            <MKTypography variant="body2" color="text" mb={2}>
              {t("features.description")}
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6} sx={{ ml: { xs: -2, lg: "auto" }, mt: { xs: 6, lg: 0 } }}>
            <Stack className={styles.servicesBlock}>
              <MKBox
                display="flex"
                alignItems="center"
                p={2}
                component="a"
                href={serviceLinks[0]}
                sx={{
                  textDecoration: "none",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.02)", borderRadius: 1 },
                }}
              >
                <MKBox
                  width="3rem"
                  height="3rem"
                  variant="gradient"
                  bgColor="info"
                  color="white"
                  coloredShadow="info"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="xl"
                  className={styles.iconBox}
                >
                  <Icon fontSize="small">code</Icon>
                </MKBox>
                <MKTypography variant="body2" color="text" pl={2}>
                  <Link href={serviceLinks[0]} color="info" sx={{ textDecoration: "none" }}>
                    <span className={styles.serviceTitle}>{t("features.service1Title")}</span>
                  </Link>
                  <br />
                  {t("features.service1Desc")}
                </MKTypography>
              </MKBox>
              <MKBox
                display="flex"
                alignItems="center"
                p={2}
                component="a"
                href={serviceLinks[1]}
                sx={{
                  textDecoration: "none",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.02)", borderRadius: 1 },
                }}
              >
                <MKBox
                  width="3rem"
                  height="3rem"
                  variant="gradient"
                  bgColor="info"
                  color="white"
                  coloredShadow="info"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="xl"
                  className={styles.iconBox}
                >
                  <Icon fontSize="small">settings_overscan</Icon>
                </MKBox>
                <MKTypography variant="body2" color="text" pl={2}>
                  <Link href={serviceLinks[1]} color="info" sx={{ textDecoration: "none" }}>
                    <span className={styles.serviceTitle}>{t("features.service2Title")}</span>
                  </Link>
                  <br />
                  {t("features.service2Desc")}
                </MKTypography>
              </MKBox>
              <MKBox
                display="flex"
                alignItems="center"
                p={2}
                component="a"
                href={serviceLinks[2]}
                sx={{
                  textDecoration: "none",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.02)", borderRadius: 1 },
                }}
              >
                <MKBox
                  width="3rem"
                  height="3rem"
                  variant="gradient"
                  bgColor="info"
                  color="white"
                  coloredShadow="info"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="xl"
                  className={styles.iconBox}
                >
                  <Icon fontSize="small">interpreter_mode</Icon>
                </MKBox>
                <MKTypography variant="body2" color="text" pl={2}>
                  <Link href={serviceLinks[2]} color="info" sx={{ textDecoration: "none" }}>
                    <span className={styles.serviceTitle}>{t("features.service3Title")}</span>
                  </Link>
                  <br />
                  {t("features.service3Desc")}
                </MKTypography>
              </MKBox>
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default FeaturesOne;
